class ActiveLink extends HTMLElement {
  connectedCallback() {
    const currentUrl = window.location.pathname;
    const links = this.querySelectorAll('a'); 

    links.forEach(link => {
      const href = link.getAttribute('href');
      // Check for exact match or match with trailing slash for blog tags
      if (href === currentUrl || href === currentUrl + '/') {
        link.classList.add('active');
      }
    });
  }
}

customElements.define('active-link', ActiveLink);